<script>
  import GeneralButton from "../../components/button/GeneralButton.svelte"
  import { usePageContext } from "../../components/pages/pageContext.js"
  import {
    getDispatchingViewProfile1Configuration,
    saveDispatchingViewProfile1Configuration
  } from "../../utils/configurationStorage/views/DispatchingViewProfile1ConfigurationStorage.js"
  import { navigateI18n } from "../../i18n/navigate.js";
  import { sortResourcesByDisplayOrder } from "../../views/generic/DispatchingView/utils.js";

  export let projectId = ""
  export let resources = null
  export let resourceGroups = null
  export let resetTransactions = null
  export let user

  const {setHeaderProps} = usePageContext()
  setHeaderProps({title: "担当者CD選択"})

  let selected = "未指定"

  $: selectableResources = determineSelectableResources(resources ?? [], resourceGroups)

  function determineSelectableResources(resources, resourceGroups) {
    const resourcesInResourceGroup = new Set(resourceGroups.map(rg => rg.groupMembers).flat().map(resource => resource.code))
    return sortResourcesByDisplayOrder(resources.filter(resource => resourcesInResourceGroup.has(resource.code)))
  }

  async function onReset() {
    if (!resetTransactions) return

    const input = window.prompt("本当に実績を初期化しますか？\n初期化する場合\"Reset\"と入力してください");
    if(input === "Reset") {
      alert("実績を初期化しました")
      await resetTransactions()
    }else{
      alert("入力された文字列が\"Reset\"ではありませんでした\n実績を初期化しませんでした")
    }
  }
  const configuration = getDispatchingViewProfile1Configuration(user?.id, projectId)
  if (configuration.lastUsedResourceObjectID) {
    selected = configuration.lastUsedResourceObjectID
  }

  function gotoDetail() {
    if (selected !== "未指定") {
      saveDispatchingViewProfile1Configuration({...configuration, lastUsedResourceObjectID: parseInt(selected, 10)}, user?.id, projectId)
      navigateI18n(`/projects/${projectId}/DispatchingView_Profile1/${selected}`)
    }
  }
</script>

<!-- Reset Button -->
<div style="display: flex; margin-top: 25px">
  <GeneralButton
    buttonFunction={onReset}
    buttonText={"すべての実績をリセット"}
    width={"100"}
    height={"30"}
    buttonType="negative"
  />
</div>

<!-- Select box and confirm button -->
<div id="center-container">
  <div>
    担当者CD:
  </div>
  <!-- Select box -->
  <select id="group-selector" bind:value={selected}>
    {#if configuration.lastUsedResourceObjectID && resources && resources.filter((r) => r.objectId == configuration.lastUsedResourceObjectID).length > 0}
      <option value={configuration.lastUsedResourceObjectID}>前回の資源: {resources.filter((r) => r.objectId == configuration.lastUsedResourceObjectID)[0]?.code}</option>
    {:else}
      <option value={"未指定"}>未指定</option>
    {/if}
    {#each selectableResources as resource}
      <option value={resource.objectId}>{resource["担当者コード"]}&nbsp;&nbsp;&nbsp;&nbsp;{resource.code}</option>
    {:else}
      <option value="">内部サーバエラー</option>
    {/each}
  </select>

  <!-- Confirm button -->
  <GeneralButton buttonText={"OK"} buttonFunction={gotoDetail}/>
</div>

<style>
  #center-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  #group-selector {
    color: #6280ba;
    border-color: #6280ba;
    border-radius: 5px;
    text-align: center;
    width: 600px;
    height: 30px;
    margin-left: 25px;
  }
  @media (max-width: 992px) {
    #group-selector {
      width: 90%;
    }
  }

</style>
